import React from 'react'
import ReactGA from 'react-ga'
import logo from '../images/large_tree_logo.png'

export default class extends React.Component {

    componentWillMount() {
        ReactGA.pageview(location.pathname)
    }

    render() {
        return (
            <div id="error_page" style={{textAlign: "center"}} className="layout-column layout-align-center">
                <img alt="morrisons logo" height="200" src={logo}></img>
                <div style={{color: "#004E37", fontSize: "24px", padding: "20px"}}>
                    Oops! Something has gone wrong. It's not you, it's us. Please try again in a few minutes.
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/pages/error.js